import { UI_STRINGS, type UiStrings } from '@/constants/ui-locale'
import { useStore } from '@/store/useStore'

/**
 * Return the active locale's string dictionary for use in non-React modules
 * (service/axios interceptors, plain async helpers). Reads the current
 * `uiLocale` snapshot from the zustand store so the message reflects the
 * user's choice at the moment the error is constructed.
 */
export function getServiceStrings(): UiStrings {
  const locale = useStore.getState().uiLocale
  return UI_STRINGS[locale]
}
